import { UserApiClientParam } from './type'
import userApiClient from './userApiClient'

const UserAPI = {
  getAlarmInfo: async ({ memberId, baseDate, page, size }: UserApiClientParam['getAlarmInfo']) => {
    try {
      const formattedDate = new Date().toISOString().replace(/T.*$/, '').trim()

      const res = await userApiClient.get(`v1/broadcast/alarms/members/${memberId}`, {
        params: {
          baseDate: baseDate ?? formattedDate,
          page: page ?? 1,
          size: size ?? 10,
        },
      })
      return res.data
    } catch (error) {
      console.log(error)
    }
  },
  subscribeAlarm: async (ReqBroadcastAlarms: UserApiClientParam['subscribeAlarm']) => {
    try {
      const res = await userApiClient.patch(`v1/broadcast/alarms`, ReqBroadcastAlarms)
      return res.data
    } catch (error) {
      console.log(error)
    }
  },
  deleteAlarm: async (ReqBroadcastAlarms: UserApiClientParam['deleteAlarm']) => {
    try {
      const { broadcastUniqueId, partnerUniqueId, partnerMemberUniqueId } = ReqBroadcastAlarms
      const res = await userApiClient.delete(
        `v1/broadcast/alarms/cancel?broadcastUniqueId=${broadcastUniqueId}&partnerUniqueId=${partnerUniqueId}&partnerMemberUniqueId=${partnerMemberUniqueId}`,
      )
      return res.data
    } catch (error) {
      console.log(error)
    }
  },
}

export default UserAPI
